/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2Treatment/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2Treatment({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2Treatment",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 18,
  height = 18,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2 = "#E0A93D"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2Treatment.Svg"
  data-view-path={viewPath}
 viewBox="0 0 18 18"
 style={{'--as-1-2t4Vwq': alignSelf,'--mt-2-2t4Vwq': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-2t4Vwq': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-2t4Vwq': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-2t4Vwq': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-2t4Vwq': opacity,'--w-10-2t4Vwq': typeof width === 'number' ? `${width}px` : width,'--h-11-2t4Vwq': typeof height === 'number' ? `${height}px` : height,'--f-12-2t4Vwq': fill,'--a-7-2t4Vwq': isAnimated ? animation : "none",'--sd-8-2t4Vwq': isAnimated ? strokeDashoffset : 0,'--sd-9-2t4Vwq': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2Treatment.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M9 10v1.098a5 5 0 002.519 4.341l.485.277a1 1 0 00.992 0l.484-.276A5 5 0 0016 11.098V10a1 1 0 00-1-1h-5a1 1 0 00-1 1zm3.5.375c.345 0 .625.28.625.625v.625h.625a.625.625 0 110 1.25h-.625v.625a.625.625 0 11-1.25 0v-.625h-.625a.625.625 0 110-1.25h.625V11c0-.345.28-.625.625-.625zM6.999 8a3 3 0 100-6 3 3 0 000 6zm.891 1.188l.04-.101A5 5 0 001.999 14a.5.5 0 00.501.5h6.132a6.23 6.23 0 01-.882-3.188v-1.275a2.22 2.22 0 01.141-.85z"
 style={{'--f-12-2t4Vwq': fill2}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}